<template>
  <div>
    <payout-form-group :label="$t('Комиссия')"
                       :required="model.isRequiredAttribute(attribute)"
                       :has-errors="model.errors.has(errorsAttribute)">
      <payout-evaluate-fee-block :model="model"
                                :link-text="$t('Рассчитать')"
                                :evaluating-text="$t('Рассчитывается...')">
        <template v-slot:feebody="slotProps">
          <div v-if="slotProps.showFee">
            <template v-if="(slotProps.tax.feeAmount > 0)">
              {{slotProps.tax.feeTotal|moneyFormat(slotProps.tax.feeCurrency)}} {{slotProps.tax.feeCurrency}}
            </template>
            <template v-if="(slotProps.tax.cardChargeAmount > 0) && (slotProps.tax.feeAmount == 0)">
              <i18n path="message1" tag="span">
                <tempate v-slot:amount>
                  {{slotProps.tax.cardChargeAmount|moneyFormat(slotProps.tax.feeCurrency)}} {{slotProps.tax.feeCurrency}}
                </tempate>
              </i18n>
            </template>
          </div>
        </template>
        <template v-slot:afterfee="slotProps">
          <template v-if="(slotProps.tax.feeAmount > 0) && (slotProps.tax.cardChargeAmount > 0)">
            <div v-if="slotProps.showFee && (slotProps.tax.feeAmount > 0)" style="color: #aaa;
    font-size: 85%;">
              <i18n path="message2cap" tag="span">
                <template v-slot:amount>
                  {{slotProps.tax.feeAmount|moneyFormat(slotProps.tax.feeCurrency)}} {{slotProps.tax.feeCurrency}}
                </template>
              </i18n>
            </div>
            <div v-if="slotProps.showFee && (slotProps.tax.cardChargeAmount > 0)"  style="color: #aaa;
    font-size: 85%;">
              <i18n path="message2card" tag="span">
                <template v-slot:amount>
                  {{slotProps.tax.cardChargeAmount|moneyFormat(slotProps.tax.feeCurrency)}} {{slotProps.tax.feeCurrency}}
                </template>
              </i18n>
            </div>
          </template>

        </template>
      </payout-evaluate-fee-block>
    </payout-form-group>
    <payout-toggable-hint-panel-form-group
      :heading="$t('Как рассчитывается комиссия')"
      :link-text="$t('Как рассчитывается комиссия')">
      {{$t('howto1')}}
      <i18n tag="span" path="howto2">
        <template v-slot:amount>
          100 USD/EUR/RUR
        </template>
      </i18n>
    </payout-toggable-hint-panel-form-group>
  </div>
</template>

<script lang="ts">
import {Component, Prop} from "vue-property-decorator";
import {MoneyFormatFilter} from "@/models/filters/money";
import Vue from "vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutEvaluateFeeBlock from "@/components/forms/payout/PayoutEvaluateFeeBlock.vue";

import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: "PayoutCardTopUpEvaluateFeeFormGroup",
  components: {PayoutEvaluateFeeBlock, PayoutToggableHintPanelFormGroup, PayoutFormGroup},
  filters: {
    money: MoneyFormatFilter,
  },
})
export default class PayoutCardTopUpEvaluateFeeFormGroup extends Vue {
  @Prop({ default: null })
  model!: PayoutWebModel

  @Prop({ default: 'tax' })
  attribute!: string

  @Prop({ default: 'tax' })
  errorsAttribute!: string

  @Prop({ default: false })
  disabled!: boolean

  @Prop({default: 1})
  cardfee: number
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "message1": "{amount} will be charged from card",
    "message2cap": "{amount} charged from Capitalist account",
    "message2card": "{amount} will be charged from card",
    "howto1": "Capitalist service charges commission additionally from the payment amount.",
    "howto2": "For example, if a transfer is {amount}, it will be debited from your account {amount} + commission. Please consider it when calculating the transfer amount.",
    "Рассчитать": "Calculate",
    "Рассчитывается...": "Calculating...",
    "Как рассчитывается комиссия": "Commission",
    "Комиссия": "Commission"
  },
  "ru": {
    "message1": "{amount} будет списано с карты",
    "message2cap": "{amount} списывается cо счета Capitalist",
    "message2card": "{amount} будет списано с карты",
    "howto1": "В сервисе Capitalist комиссия взимается дополнительно от суммы платежа.",
    "howto2": "Если перевод составляет, к примеру, {amount}, то с Вашего счета будет списано {amount} + сумма комиссии. Пожалуйста, учитывайте это при расчете суммы перевода."
  }
}
</i18n>
